<template>
  <div id="home">
    <div class="mobile-home hidden-sm-and-up">
      <div class="mobile-banner">
        <div class="mobile-video-description">
          <div class="video-description-one">专注于</div>
          <div class="video-description-two">贵金属领域</div>
          <div class="video-description-three">LBMA / LPPM / SGE资质认证</div>
        </div>
        <div class="mobile-company-description">
          <div class="description-title">
            点金 POINT GOLD
          </div>
          <div class="description-title-desc">
            <span>专</span>
            <span>注</span>
            <span>于</span>
            <span>贵</span>
            <span>金</span>
            <span>属</span>
            <span>领</span>
            <span>域</span>
          </div>
          <div class="description-desc">
            <a><br>点金贵金属是中国贵金属领域的领先供应商，在产能、规模、装备及技术实力方面均处于行业前列。公司以珠宝首饰研发与制造起步，当下以贵金属全球贸易与金融和贵金属新材料研发与加工为发展重点，力求助推客户价值的不断提升。</a>
          </div>
        </div>
      </div>
      <div class="mobile-description-photo">
        <div class="item item-one">
          <div class="description">
            <!-- <a id="a1">深圳市</a> -->
            <a id="a2" href="#/jinMingFengJewelry" @click="scrollToTop" style="text-decoration: none;color: white;">金明丰珠宝有限公司</a>
            <a id="a3" href="#/jinMingFengJewelry" @click="scrollToTop" style="text-decoration: none;color: white;">专注于贵金属珠宝首饰研发与制造</a>
          </div>
        </div>
        <div class="item item-two">
          <div class="description">
            <!-- <a id="a1">深圳市</a> -->
            <a id="a2" href="#/midasRefining" @click="scrollToTop" style="text-decoration: none;color: white;">点金贵金属精炼有限公司</a>
            <a id="a3" href="#/midasRefining" @click="scrollToTop" style="text-decoration: none;color: white;">专注于贵金属生产、贸易与金融</a>
          </div>
        </div>
        <div class="item item-three">
          <div class="description">
            <!-- <a id="a1">深圳市</a> -->
            <a id="a2" href="#/midianNewMaterials" @click="scrollToTop" style="text-decoration: none;color: white;">点金金属材料科技有限公司</a>
            <a id="a3" href="#/midianNewMaterials" @click="scrollToTop" style="text-decoration: none;color: white;">专注于贵金属材料研发与加工</a>
          </div>
        </div>
      </div>
      <div class="mobile-product-service">
        <div class="product-service-title">
          <a>产品服务</a><br>
          <a class="product-service-a1">坚守高品质产品与服务</a><br>
          <a class="product-service-a2">致力与全球合作伙伴一起，通过持续创新的贵金属解决方案，来推动各产业、各业务的健康增长</a>
        </div>
        <div class="product-service-photo">
          <div class="product-service-photo-one">
            <a href="#/jewelry" class="overlay-link" @click="scrollToTop">
            <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/product-one-mobile.png" alt="" class="service-photo-one"></a>
          </div>
          <div class="product-service-photo-two">
            <a href="#/materialProduct" class="overlay-link" @click="scrollToTop">
            <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/product-three-mobile.png" alt=""></a>
            <a href="#/bullion" class="overlay-link" @click="scrollToTop">
            <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/product-two-mobile.png" alt=""></a>
          </div>
          <div class="product-service-photo-one"> 
            <a href="#/recyclingRefining" class="overlay-link" @click="scrollToTop">
              <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/product-four-mobile.png" alt="" class="service-photo-two"></a>
          </div>
          <div class="product-service-photo-two">
            <a href="#/analyze" class="overlay-link" @click="scrollToTop">
            <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/product-five-mobile.png" alt=""></a>
          </div>
        </div>
      </div>
      <div class="mobile-news">
        <div class="news-special" @click="handleArticleClick(specialId)">
          <img :src=specialPictureUrl alt="">
          <div class="news-flag">
            <a>{{specialFlag}}</a>
          </div>
          <div class="news-special-text">
            <div class="news-special-text-a">{{specialTitle}}</div>
            <div class="special-text-a">{{specialContent}}</div>
          </div>
          <div class="segmentation"></div>
        </div>
        <div class="news-special"  @click="handleArticleClick(normalIdOne)">
          <img :src=normalPictureUrlOne alt="">
          <div class="news-flag">
            <a>{{normalFlagOne}}</a>
          </div>
          <div class="news-special-text">
            <div class="news-special-text-a">{{normalTitleOne}}</div>
            <div class="special-text-a">{{normalContentOne}}</div>
          </div>
          <div class="segmentation"></div>
        </div>
        <div class="news-special final-news"  @click="handleArticleClick(normalIdTwo)">
          <img :src=normalPictureUrlTwo alt="">
          <div class="news-flag">
            <a>{{normalFlagTwo}}</a>
          </div>
          <div class="news-special-text">
            <div class="news-special-text-a">{{normalTitleTwo}}</div>
            <div class="special-text-a">{{normalContentTwo}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden-xs-only">
      <video id="home-video" muted="muted" autoplay="autoplay" poster="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/video/home-vedio.jpg" loop x5-playsinline playsinline webkit-playsinline>
        <source src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/video/home-vedio.mp4" type="video/mp4">
      </video>
      <div class="video-description">
        <div class="video-description-one">专注于</div>
        <div class="video-description-two">贵金属领域</div>
        <div class="video-description-three">LBMA / LPPM / SGE资质认证</div>
      </div>
      <div class="company-description">
        <div class="description-title">
         点金 POINT GOLD
        </div>
        <div class="description-title-desc">
          <span>专</span>
          <span>注</span>
          <span>于</span>
          <span>贵</span>
          <span>金</span>
          <span>属</span>
          <span>领</span>
          <span>域</span>
        </div>
       <div class="description-desc">
         <a>点金贵金属是中国贵金属领域的领先供应商，在产能、规模、装备及技术实力方面均处于行业前列。<br>
          公司以珠宝首饰研发与制造起步，当下以贵金属全球贸易与金融和贵金属新材料研发与加工为发展重点，力求助推客户价值的不断提升。</a>
       </div>
       <div class="description-photo">
          <a class="item" href="#/jinMingFengJewelry" @click="scrollToTop">
            <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/description-one.png" alt="" class="image">
            <div class="description">
              <!-- <a id="a1">深圳市</a> -->
              <div style="height: 20px;"></div>
              <a id="a2">金明丰珠宝有限公司</a>
              <a id="a3">专注于贵金属珠宝首饰研发与制造</a>
            </div>
          </a>
          <a class="item" href="#/midasRefining" @click="scrollToTop">
            <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/description-two.png" alt="" class="image">
            <div class="description">
              <!-- <a id="a1">深圳市</a> -->
              <div style="height: 20px;"></div>
              <a id="a2">点金贵金属精炼有限公司</a>
              <a id="a3">专注于贵金属生产、贸易与金融</a>
            </div>
          </a>
          <a class="item" href="#/midianNewMaterials" @click="scrollToTop">
            <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/description-three.png" alt="" class="image">
            <div class="description">
              <!-- <a id="a1">深圳市</a> -->
              <div style="height: 20px;"></div>
              <a id="a2">点金金属材料科技有限公司</a>
              <a id="a3">专注于贵金属材料研发与加工</a>
            </div>
          </a>
        </div>
      </div>
      <div class="product-service">
        <div class="product-service-title">
          <a>产品服务</a><br>
          <a class="product-service-a1">坚守高品质产品与服务</a><br>
          <a class="product-service-a2">致力与全球合作伙伴一起，通过持续创新的贵金属解决方案，来推动各产业、各业务的健康增长。</a>
        </div>
        <div class="product-service-photo">
          <div class="column-single">
            <div class="photo-wrapper">
              <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/product-one.png" alt="">
              <div class="overlay" style="margin-top: 40px;">
                <a href="#/jewelry" class="overlay-link" @click="scrollToTop">珠宝首饰</a>
              </div>
            </div>
          </div>
          <div class="column-double">
            <div class="photo-wrapper">
              <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/product-two.png" alt="">
              <div class="overlay001">
                <a href="#/bullion" class="overlay-link001" @click="scrollToTop">金锭、金条</a>
              </div>
            </div>
            <div class="photo-wrapper">
              <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/product-four.png" alt="" class="img001">
              <div class="overlay002">
                <a href="#/materialProduct" class="overlay-link001" @click="scrollToTop">贵金属材料产品</a>
              </div>
            </div>
          </div>
          <div class="column-double double001">
            <div class="photo-wrapper">
              <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/product-three.png" alt="">
              <div class="overlay003">
                <a href="#/recyclingRefining" class="overlay-link001" @click="scrollToTop">回收与精炼</a>
              </div>
            </div>
            <div class="photo-wrapper">
              <img src="https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/product-five.png" alt="" class="img001">
              <div class="overlay004">
                <a href="#/analyze" class="overlay-link001" @click="scrollToTop">分析服务</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="news">
        <div class="news-special" @click="handleArticleClick(specialId)">
          <img :src=specialPictureUrl alt="">
          <div class="news-special-text">
            <span class="news-special-text-a">{{specialTitle}}</span>
            <span class="special-text-a">{{specialContent}}</span>
          </div>
        </div>
          <div class="news-normal hidden-xs-only">
            <div class="news-normal-div" @click="handleArticleClick(normalIdOne)">
              <div class="news-normal-flag">
                <a>{{normalFlagOne}}</a>
              </div>
              <div class="news-normal-title">{{normalTitleOne}}</div>
              <div class="news-normal-news">{{normalContentOne}}</div>
              <div class="news-normal-img">
                <img :src=normalPictureUrlOne alt="">
              </div>
              
            </div>
            <div class="news-normal-div" @click="handleArticleClick(normalIdTwo)">
              <div class="news-normal-flag">
                <a>{{normalFlagTwo}}</a>
              </div>
              <div class="news-normal-title">{{normalTitleTwo}}</div>
              <div class="news-normal-news">{{normalContentTwo}}</div>
              <div class="news-normal-img">
                <img :src=normalPictureUrlTwo alt="">
              </div>
            </div>
            <div class="news-normal-div" @click="handleArticleClick(normalIdThree)">
              <div class="news-normal-flag">
                <a>{{normalFlagThree}}</a>
              </div>
              <div class="news-normal-title">{{normalTitleThree}}</div>
              <div class="news-normal-news">{{normalContentThree}}</div>
              <div class="news-normal-img">
                <img :src=normalPictureUrlThree alt="">
              </div>
            </div>
            <div class="news-normal-div" @click="handleArticleClick(normalIdFour)">
              <div class="news-normal-flag">
                <a>{{normalFlagFour}}</a>
              </div>
              <div class="news-normal-title">{{normalTitleFour}}</div>
              <div class="news-normal-news">{{normalContentFour}}</div>
              <div class="news-normal-img">
                <img :src=normalPictureUrlFour alt="">
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:"Home",
  data () {
    return {
      specialId: undefined,
      specialTitle:undefined,
      specialContent:undefined,
      specialPictureUrl:undefined,
      specialFlag:undefined,

      normalIdOne:undefined,
      normalTitleOne:undefined,
      normalContentOne:undefined,
      normalPictureUrlOne:undefined,
      normalFlagOne:undefined,

      normalIdTwo:undefined,
      normalTitleTwo:undefined,
      normalContentTwo:undefined,
      normalPictureUrlTwo:undefined,
      normalFlagTwo:undefined,

      normalIdThree:undefined,
      normalTitleThree:undefined,
      normalContentThree:undefined,
      normalPictureUrlThree:undefined,
      normalFlagThree:undefined,

      normalIdFour:undefined,
      normalTitleFour:undefined,
      normalContentFour:undefined,
      normalPictureUrlFour:undefined,
      normalFlagFour:undefined,
    }
  },
  created () {
    this.getNews()
  },
  mounted() {},
  methods: {
    scrollToTop() {
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    },
    getNews() {
      this.$api.news({'language': 'cn'}).then(response => {
        if (response.code === 200) {
          const specialNews = response.data.filter(item => item.type === 0)
          if (specialNews.length > 0) {
            const specialNew = specialNews[0]
            this.specialId = specialNew.newsId
            this.specialTitle = specialNew.title
            this.specialContent = specialNew.content
            this.specialPictureUrl = specialNew.pictureUrl
            this.specialFlag = specialNew.flag
          }
          const normalNews = response.data.filter(item => item.type !== 0)
          normalNews.sort((a, b) => a.weight - b.weight)
          for (let i = 0; i < Math.min(normalNews.length, 4); i++) {
            const id = normalNews[i].newsId
            const title = normalNews[i].title
            const content = normalNews[i].content
            const pictureUrl = normalNews[i].pictureUrl
            const flag = normalNews[i].flag
            switch (i) {
              case 0:
                this.normalIdOne = id
                this.normalTitleOne = title
                this.normalContentOne = content
                this.normalPictureUrlOne = pictureUrl
                this.normalFlagOne = flag
                break;
              case 1:
                this.normalIdTwo = id
                this.normalTitleTwo = title
                this.normalContentTwo = content
                this.normalPictureUrlTwo = pictureUrl
                this.normalFlagTwo = flag
                break;
              case 2:
                this.normalIdThree = id
                this.normalTitleThree = title
                this.normalContentThree = content
                this.normalPictureUrlThree = pictureUrl
                this.normalFlagThree = flag
                break;
              case 3:
                this.normalIdFour = id
                this.normalTitleFour = title
                this.normalContentFour = content
                this.normalPictureUrlFour = pictureUrl
                this.normalFlagFour = flag
                break;
              default:
                break;
            }
          }
        } else {
          this.msgError('网页正在升级中...')
        }
      })
    },
    handleArticleClick(id) {
      const route = this.$router.resolve({ name: 'details', params: { id: id} })
      if (route.resolved && route.resolved.name === 'details') {
        this.$router.push({ name: 'details', params: { id: id } })
      } else {
        this.$router.push('/details404')
      }
    }
  }
}
</script>

<style scoped lang="scss">
#home{
  #home-video {
    width: 100%;
  }
  .video-description {
    width: 50%;
    position: absolute;
    top: 40%;
    left: 34%;
    transform: translate(-50%, -50%);
    padding: 5px;
    z-index: 1;
    color: rgba(255, 255, 255, 1);
    font-size: 85px;
    font-weight: 400;
    .video-description-three {
      margin-top: 10px;
      font-size: 25px;
      color: #ffffff;
      font-weight: 300;
      margin-left: 1%;
    }
  }
  
  .company-description {
    margin-top: 58px;
    padding-left: 10%;
    padding-right: 10%;
    .description-title {
      color: #4A2D85;
      font-size: 24px;
      font-weight: bolder;
    }
    .description-title-desc {
      color: #4A2D85;
      font-size: 22px;
      span {
        margin-right: 5px;
      }
    }
    .description-desc {
      font-size: 20px;
      margin-top: 10px;
      color: #333333;
      font-weight: 300;
      letter-spacing: 1px; 
      line-height: 1.6;
    }
    .description-photo {
      display: flex;
      justify-content: space-between;
      gap: 10px; /* 设置项目之间的间距 */
      margin-top: 20px;
      display: flex;
    }
    .item {
      position: relative;
      width: 32%;
      background: #fff;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      overflow: hidden;
      text-decoration: none; /* 去除链接默认下划线 */
      color: inherit; /* 继承父元素颜色 */
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    .item:hover {
      transform: translateY(-10px);
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
    }

    .image {
      width: 100%;
      height: auto;
      transition: transform 0.3s ease;
    }

    .item:hover .image {
      transform: scale(1.08);
    }

    .description a {
      display: block;
      // color: #0e0e0e;
      text-decoration: none;
      margin: 5px 0;
      // transition: color 0.3s ease;
    }
    .description{
      padding: 15px;
      text-align: center;
      margin-top: -10px;
      overflow: hidden;
      transition: opacity 0.3s ease;
      top: 0;
      left: 0;
      background-color: #796BAF;
      height: 100px;
      width: 98%;
      // display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      color: #ffffff;
      #a1 {
        font-size: 22px;
        font-weight: 500;
        letter-spacing: 2px;
      }
      #a2 {
        font-size: 22px;
        font-weight: bold;
        letter-spacing: 2px;
      }
      #a3 {
        font-size: 18px;
        font-weight: normal;
        letter-spacing: 4px;
      }
    }

    .description a {
      display: block;
      font-size: 20px;
    }
    .item:hover .description a {
      font-size: 60px;
      color: white;
      z-index: 1;
    }
  }
  .product-service{
    background-color: #4A2D85;
    margin-top: -60px;
    padding-left: 10%;
    padding-right: 10%;
    .product-service-title {
      position: relative;
      top: 140px;
      font-weight: bolder;
      color: #ffffff;
      font-size: 24px;
      letter-spacing: 2px;
      .product-service-a1 {
        font-size:22px;
        font-weight: 300;
        letter-spacing: 2px;
      }
      .product-service-a2 {
        font-weight:300;
        font-size: 20px;
        position: relative;
        letter-spacing: 3px;
        top: 6px;
      }
    }
    .product-service-photo {
      padding-bottom: 30px;
      display: flex;
      width: 100%;
      margin-top: 165px;
      margin-left: -20px;
      .column-single, .column-double {
        display: flex;
        flex-direction: column;
        gap: 20px; /* 添加间距 */
      }
      .column-single {
        width: 48%;
      }
      .column-double {
        width: 28%;
      }
      .photo-wrapper {
          position: relative;
          overflow: hidden;
          border-radius: 10px; /* 确保photo-wrapper有相同的边框圆角 */
      }

      img {
        display: block;
        width: 100%;
        height: auto;
        transition: transform 0.3s ease;
        border-radius: 10px; /* 确保img有相同的边框圆角 */
      }
      .img001 {
        margin-top: -10px;
      }
      .overlay, .overlay001, .overlay002, .overlay003, .overlay004 {
          position: absolute;
          top: 32%;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: opacity 0.3s ease;
      }
      .overlay-link,.overlay-link001 {
        position: relative;
        font-size: 1.5em;
        color: white;
        text-decoration: none;
        padding: 5px 15px; /* 设置内边距 */
        background: #4A2D85;; /* 设置背景颜色 */
        opacity: 1;
        border-radius: 5px; /* 设置圆角 */
      }
      .overlay-link001{
        font-size: 1.2em;
      }
      .photo-wrapper:hover img {
        transform: scale(1.05);
      }
      // .photo-wrapper:hover .overlay,.photo-wrapper:hover .overlay001,.photo-wrapper:hover .overlay002,.photo-wrapper:hover .overlay003,.photo-wrapper:hover .overlay004 {
      //   opacity: 1.2;
      // }
    }
  }
  .news {
    padding-left: 10%;
    padding-right: 10%;
    margin-top: 70px;
    .news-special {
      display: flex;
      img {
        width: 40%;
        margin-right: 5%;
      }
      .news-special-text {
        span {
          display: block;
        }
        .news-special-text-a {
          font-size: 30px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .special-text-a {
          font-size: 18px;
        }
      }
    }
    .news-normal {
      margin-top: 30px;
      display: flex;
      gap: 10px;
      padding-bottom: 3%;
      .news-normal-div {
        width: 25%;
        flex-grow: 1;
        &:hover {
          transform: translateY(-8px);
          transition-duration: 300ms;
        }
        cursor: pointer;
      }
      .news-normal-div div:not(:last-child) {
        margin-right: 40px;
      }
      .news-normal-flag {
        margin-top: 2%;
        height: 22px;
        text-align: center;
        display: flex;
        a {
          background-color: rgba(49, 49, 65, 0.314);
          color: #4A2D85;
          font-size: 14px;
          text-align: left;
          border-radius: 5px;
          padding: 0 8px;
        }
      }
      .news-normal-title {
        margin-top: 5px;
        font-size: 18px;
        font-weight: bolder;
      }
      .news-normal-news {
        margin-top: 15px;
        font-size: 16px;
        font-weight: 300;
      }
      .news-normal-img {
        margin-top: 20px;
        margin-right: 50px;
        img {
          width: 100%;
        }
      }
    }
  }

  .mobile-home {
    .mobile-banner {
      // background-image: url("https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/mobile-banner.png");
      background-image:url("https://sfevip.oss-cn-hongkong.aliyuncs.com/mobile/firstpage/17.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      height: 650px;
      width: 100%;
      .mobile-video-description {
        width: 80%;
        top: 16%;
        left: 5%;
        font-size: 50px;
        font-weight: bolder;
        color: #ffffff;
        position: absolute;
        .video-description-three {
          font-size: 18px;
          color: #ffffff;
          font-weight: lighter;
          margin-left: 1%;
        }
      }
      .mobile-company-description {
        border-radius: 3px;
        top: 50%;
        left: 4%;
        right: 4%;
        height: 280px;
        opacity: 1;
        position: absolute;
        background-color: #ffffff;
        .description-title {
          color: #4A2D85;
          font-weight: bolder;
          font-size: 22px;
          margin-top: 10%;
          margin-left: 5%;
        }
        .description-title-desc {
          color: #4A2D85;
          font-size: 20px;
          span {
            margin-right: 4px;
          }
          margin-left: 5%;
        }
        .description-desc {
          margin-top: 5px;
          color: black;
          margin-left: 5%;
          margin-right: 5%;
        }
      }
    }
    .mobile-description-photo {
      height: 600px;
      background-color: #4A2D85;
      padding-top: 15%;
      padding-bottom: 15%;
      .item {
        height: 180px;
        margin-right: 4%;
        margin-left: 4%;
      }
      .item-one {
        background-image: url("https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/desc-one.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center center;
      }
      .item-two {
        margin-top: 5%;
        background-image: url("https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/desc-two.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center center;
      }
      .item-three {
        margin-top: 5%;
        background-image: url("https://sfevip.oss-cn-hongkong.aliyuncs.com/assets/images/desc-three.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center center;
      }
      .description{
        height: 100px;
        width: 80%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        color: #ffffff;
        padding-left: 10%;
        padding-top: 8%;
        #a1 {
          right: 10%;
          font-size: 20px;
          font-weight: bold;
        }
        #a2 {
          font-size: 20px;
          font-weight: bold;
        }
        #a3 {
          font-size: 16px;
          font-weight: normal;
        }
      }
    }
    .mobile-product-service {
      height: 550px;
      background-color: #4A2D85;
      .product-service-title {
        position: relative;
        font-weight: bolder;
        color: #ffffff;
        font-size: 20px;
        margin-left: 4%;
        margin-right: 4%;

        .product-service-a1 {
          font-weight: lighter;
        }

        .product-service-a2 {
          font-weight: normal;
          font-size: 16px;
          position: relative;
          top: 10px;
        }
      }
      .product-service-photo {
        margin-top: 10%;
        margin-left: 3%;
        margin-right: 3%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .product-service-photo-one {
          flex: 0 0 60%;
          .service-photo-one{
            max-width: 100%;
            max-height: 100%;
            height: auto;
            width: auto;
            border-radius: 2px;
          }
          .service-photo-two{
            max-width: 100%;
            max-height: 100%;
            // height: 110px;
            // width: 220px;
            border-radius: 2px;
            display: flex;
            flex-direction: column;
          }
        }
        .product-service-photo-two {
          margin-left: 4px;
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 1px;
          img {
            width: auto;
            border-radius: 2px;
          }
        }
      }
    }
    .mobile-news {
      padding-top: 10%;
      padding-left: 4%;
      padding-right: 4%;
      .news-special {
        img {
          width: 100%;
        }
        .news-special-text {
          .news-special-text-a {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 8px;
          }
          .special-text-a {
            font-size: 16px;
          }
        }
      }
      .final-news {
        margin-bottom: 10%;
      }
      .news-flag {
        margin-top: 2%;
        height: 20px;
        text-align: center;
        display: flex;
        a {
          background-color: #796BAF;
          color: #4A2D85;
          font-size: 13px;
          text-align: left;
          border-radius: 5px;
          padding: 0 8px;
        }
      }
      .segmentation {
        border: 1px solid #EDE4F0;
        margin-top: 8%;
        margin-bottom: 8%;
      }
    }
  }
}
</style>